import type { FacetFilter } from '@/views/Documents/views/AddDocuments/AddDocuments.types';

export const formatFacetFilters = (filters: FacetFilter[]) => {
  if (!filters.length) return undefined;

  const arr = filters.reduce((acc: string[], filter) => {
    if (filter?.facet) {
      acc.push(`${filter.facet}:${encodeURIComponent(filter.value ?? '')}`);
    }

    return acc;
  }, []);

  return arr.join(',');
};
